/**
 * หน้าสร้างแผน MPS ด้วยมือ — `?view=create` บน `/planning/manual-plan`
 * (`WO-P2-M5-010`, D-129 ข้อ 1 และ 4)
 *
 * เต็มหน้า ไม่ใช่ modal (D-126) ส่งผ่าน `POST /v1/mps-versions` เส้นเดียว (D-096)
 * — header และ lines ในคำขอเดียว ไม่มี `line_no` (ลำดับในอาร์เรย์) และไม่มี
 * `uom_code` (หน่วยหลักของสินค้า) สำเร็จเสมอได้สถานะ `DRAFT` — แก้แผนที่อนุมัติแล้ว
 * ไม่ได้ (D-129 ข้อ 2) ต้องสร้างเวอร์ชันใหม่แทน ซึ่งเป็นงานของหน้ารายละเอียด
 * (`WO-P2-M5-011`) ไม่ใช่หน้านี้
 *
 * validate ทั้งหมดอยู่ที่ `lib/mps/mpsView.ts` (`validateManualPlanDraft`,
 * `toMpsVersionCreateBody`) — ไฟล์นี้เป็น JSX ล้วน ไม่มีกฎ business ใดประกาศซ้ำที่นี่
 * error แสดงเฉพาะหลังกดบันทึกครั้งแรก (`submitAttempted`) เพื่อไม่ให้ขึ้นแดงทั้งฟอร์ม
 * ตั้งแต่ยังไม่ได้แตะอะไรเลย
 *
 * **`copyFromMpsId` (D-129 ข้อ 2, `WO-P2-M5-011`)** — มาจากปุ่ม "สร้างเวอร์ชันใหม่
 * จากแผนนี้" บนหน้ารายละเอียด (`?view=create&from=<mps_id>`) โหลดแผนต้นทางด้วย
 * `fetchMpsVersion` แล้วเติมโรงงาน/ช่วงวางแผน/หมายเหตุ/ทุกบรรทัดให้ (ไม่มีชื่อเวอร์ชัน
 * ให้เว้นอีกแล้ว — D-132 ข้อ 1) โหลดไม่สำเร็จ/404 ไม่ใช่ความผิดพลาดที่ปิดกั้นหน้าจอ —
 * แสดงข้อความแล้วปล่อยให้ใช้ฟอร์มเปล่าต่อได้ตามปกติ (ไม่มี `copyFromMpsId` = พฤติกรรม
 * เดิมของ `WO-P2-M5-010` ทุกอย่าง ไม่มีการเรียก `fetchMpsVersion` เลย)
 *
 * ⚠️ ไม่ใช่ด่านความปลอดภัย — เซิร์ฟเวอร์เป็นผู้ตัดสินทุกคำขอเสมอ (`can_create` ที่
 * หน้าจอนี้พึ่งแค่ซ่อนปุ่ม/ฟอร์มไม่ให้กรอกงานที่รู้อยู่แล้วว่าจะถูกปฏิเสธ)
 *
 * **D-131 (WO-P2-M5-013)** — สำเร็จนำทางไป `/planning/production-plan?mps=<id>` เอง
 * ด้วย `useNavigate` พร้อม router state `{ manualPlanCreated }` ที่หน้านั้นอ่าน; ปุ่ม
 * "ยกเลิก" กลับด้วย `navigate(-1)` ถ้ามีประวัติ (`location.key !== 'default'`) ไม่งั้น
 * กลับ `/planning/production-plan`
 *
 * **D-132 ข้อ 1** — ไม่มีช่อง "ชื่อเวอร์ชัน" อีกแล้ว เซิร์ฟเวอร์ออกเลข
 * `MPS-<plant>-<YYMM>-<4 หลัก>` ให้เองเสมอ (`result.version.version_label` ที่ส่งต่อ
 * ไปหน้าแผนการผลิตมาจาก**คำตอบของเซิร์ฟเวอร์เท่านั้น**)
 *
 * **D-132 ข้อ 2** — ตารางบรรทัดมีคอลัมน์ Part Name/Model อ่านอย่างเดียวถัดจากรหัส
 * สินค้า เติมเมื่อรหัสที่เลือก/พิมพ์ตรงกับสินค้าที่โหลดมาตอนเปิดหน้า (ครั้งเดียวต่อ
 * การเปิดหน้า ไม่ยิงต่อบรรทัดหรือต่อคำค้น ต่างจากช่อง Part Number ของหน้ารับใบสั่งซื้อ
 * D-117 ที่ยิง `GET /v1/products?q=` ทุกคำค้น) — **ไล่ตาม `next_cursor` จนครบทุกหน้า
 * (เพดาน 10 หน้า × 200 ตัว/หน้า = ไม่เกิน 2000 รายการ) ไม่ใช่หน้าแรกหน้าเดียว** โรงงาน
 * ที่มีสินค้า ACTIVE เกิน 200 ตัวต้องเห็นสินค้าตัวหลัง ๆ ด้วย ไม่งั้นรหัสที่ถูกต้องจะ
 * โดนข้อความ "ไม่พบรหัสสินค้านี้" ที่หน้าจอมั่วเอง (bug ที่พบจาก code review)
 *
 * **หน้าใดหน้าหนึ่งพังระหว่างไล่ หรือไล่จนครบเพดานแต่ `next_cursor` ยังไม่ null →
 * ทะเบียนถือว่า "ไม่ครบ" (`complete: false`)** — ใช้รายการที่เก็บมาได้แล้ว resolve
 * Part Name/Model ต่อไปได้ตามปกติ (ดีกว่าไม่มีอะไรให้ resolve เลย) แต่**ปิดการตรวจ
 * "ไม่พบรหัสสินค้านี้" ฝั่งหน้าจอทั้งหมด** (`knownProductCodes` เป็น `null`) ปล่อยให้
 * เซิร์ฟเวอร์ตัดสินรหัสที่ไม่ได้อยู่ในหน้าที่โหลดมา — ตรวจเฉพาะตอนที่มั่นใจว่าเห็น
 * สินค้า ACTIVE ทุกตัวแล้วจริง ๆ เท่านั้น ไม่งั้นรหัสที่ถูกต้องแต่อยู่หน้าที่โหลดไม่ได้
 * จะถูกบล็อกไม่ให้ส่งทั้งที่ไม่ควร หน้าแรกพังเลย (ไม่มีรายการใดเก็บมาได้) ยังคงเป็น
 * `status: 'failed'` เหมือนเดิม — ไม่ต่างจากไม่ครบ (ไม่ตรวจรหัส) แต่ไม่มีอะไรให้
 * resolve เลยสักตัว โหลดไม่สำเร็จ/ไม่ครบไม่บล็อกฟอร์ม — พิมพ์รหัสมือได้ตามปกติเสมอ
 */

import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { StatusBadge } from '../StatusBadge';
import { DateRangePicker } from '../components/DateRangePicker';
import { InfoHint } from '../components/InfoHint';
import { SearchableSelect } from '../components/SearchableSelect';
import { selectablePlants } from '../productionOrders/productionOrderView';
import { createMpsVersion, fetchMpsVersion, ruleFromMpsFailure, type MpsFailure } from '../../lib/mps/client';
import {
  manualPlanDraftFromVersion,
  manualPlanLineErrorLabel,
  manualPlanProductSelectOptions,
  toMpsVersionCreateBody,
  validateManualPlanDraft,
  withClearedManualPlanLineProductCode,
  withResolvedManualPlanLineProduct,
  type ManualPlanHeaderDraft,
  type ManualPlanLineDraft,
} from '../../lib/mps/mpsView';
import { MPS_NOTE_MAX_LENGTH, PLANNING_MODULE } from '../../lib/mps/types';
import type { PermissionsState } from '../../lib/permissions/types';
import { fetchProductList } from '../../lib/products/client';
import type { Product } from '../../lib/products/types';
import { findProductByExactCode } from '../../lib/sales/salesView';

/** จำนวนสินค้าต่อหน้าที่ขอจากเซิร์ฟเวอร์ — เพดานของ contract คือ 200 (D-132 ข้อ 2) */
const MANUAL_PLAN_PRODUCT_PAGE_LIMIT = 200;
/** จำนวนหน้าสูงสุดที่ไล่ตาม `next_cursor` — กันวนไม่จบถ้าทะเบียนใหญ่ผิดปกติ
 * (10 × 200 = ไม่เกิน 2000 รายการ) เกินนี้ถือว่าทะเบียน "ไม่ครบ" (ดูด้านบน) */
const MANUAL_PLAN_PRODUCT_MAX_PAGES = 10;

export interface ManualPlanCreateViewProps {
  readonly permissions: PermissionsState;
  readonly apiBaseUrl: string;
  /** inject ได้เพื่อการทดสอบ — production ใช้ `fetch` ของเบราว์เซอร์ */
  readonly fetchImpl?: typeof fetch;
  /** `mps_id` ของแผนต้นทางที่กำลังคัดลอก — `null`/`undefined` = ฟอร์มเปล่าตามปกติ */
  readonly copyFromMpsId?: string | null;
}

type CopySourceState =
  | { readonly status: 'idle' }
  | { readonly status: 'loading' }
  | { readonly status: 'done' }
  | { readonly status: 'failed'; readonly failure: MpsFailure };

/**
 * สถานะของทะเบียนสินค้าที่โหลดมาตอนเปิดหน้า (D-132 ข้อ 2) — `'ready'` มี `complete`
 * แยกจาก `items`: `complete: false` แปลว่าไล่หน้าไม่จบ (พังกลางทางหรือชนเพดาน) ใช้
 * `items` ที่เก็บมาได้ resolve ต่อได้ แต่ห้ามใช้ตรวจ "ไม่พบรหัส" (ดู `knownProductCodes`)
 * `'failed'` คือพังตั้งแต่หน้าแรก ไม่มีรายการใดให้ resolve เลย
 */
type ManualPlanProductsState =
  | { readonly status: 'loading' }
  | { readonly status: 'ready'; readonly items: readonly Product[]; readonly complete: boolean }
  | { readonly status: 'failed' };

function emptyLine(key: number): ManualPlanLineDraft {
  return { key, productCode: '', productName: '', model: '', bucketDate: '', plannedQty: '' };
}

function failureHeading(failure: MpsFailure): string {
  switch (failure.status) {
    case 'unauthenticated':
      return 'ต้องเข้าสู่ระบบก่อนจึงจะใช้หน้าจอนี้ได้';
    case 'forbidden':
      return 'สิทธิ์ชุดนี้ไม่ครอบคลุมคำขอนี้';
    case 'not-found':
      return 'ไม่พบโรงงานนี้';
    case 'conflict':
      return 'คำขอนี้ชนกับสถานะปัจจุบัน';
    case 'rule-violation':
      return 'คำขอนี้ติดกฎทางธุรกิจ';
    case 'bad-request':
      return 'คำขอนี้ถูกปฏิเสธว่าไม่ถูกต้อง';
    case 'server-error':
      return `เซิร์ฟเวอร์ตอบ ${failure.httpStatus}`;
    case 'network-error':
      return 'ติดต่อเซิร์ฟเวอร์ไม่ได้';
    case 'invalid-response':
      return 'ข้อมูลจากเซิร์ฟเวอร์ผิดรูปแบบ';
    case 'cancelled':
      return 'ยกเลิกการเรียกข้อมูลแล้ว';
  }
}

function failureText(failure: MpsFailure): string {
  const rule = ruleFromMpsFailure(failure);
  switch (failure.status) {
    case 'unauthenticated':
      return 'เซสชันหมดอายุหรือถูกยกเลิกไปแล้ว (D-049)';
    case 'forbidden':
      return `คำขอนี้ต้องการโมดูล ${PLANNING_MODULE} สิทธิ์ CREATE ซึ่งแผนกของคุณไม่ถือ`;
    case 'not-found':
      return 'โรงงานที่เลือกไม่มีอยู่ หรืออยู่นอกขอบเขตของคุณ';
    case 'conflict':
      return 'เซิร์ฟเวอร์ตอบ 409';
    case 'rule-violation':
      return rule === null ? 'เซิร์ฟเวอร์ตอบ 422 พร้อมกฎทางธุรกิจ' : `เซิร์ฟเวอร์ตอบ 422 พร้อมกฎ ${rule}`;
    case 'bad-request':
      return 'ข้อมูลที่ส่งไปไม่ตรงรูปแบบที่ API รับ';
    case 'server-error':
      return 'คำขอไปถึงเซิร์ฟเวอร์แล้วแต่ทำงานไม่สำเร็จ';
    case 'network-error':
      return failure.detail;
    case 'invalid-response':
      return 'หน้าจอปฏิเสธที่จะอ่านคำตอบที่ผิดรูป';
    case 'cancelled':
      return 'คำขอถูกยกเลิกก่อนได้รับคำตอบ';
  }
}

function CreateFailureNotice({ failure }: { readonly failure: MpsFailure }) {
  const rule = ruleFromMpsFailure(failure);
  const serverMessage = 'error' in failure ? failure.error.message : null;
  return (
    <div className="cap-notice" data-testid="manual-plan-create-failure" data-failure={failure.status} role="status">
      <StatusBadge tone="danger">บันทึกไม่สำเร็จ</StatusBadge>
      <h3 className="cap-notice__title">{failureHeading(failure)}</h3>
      <p className="cap-notice__text">{failureText(failure)}</p>
      {rule === null ? null : (
        <p className="cap-notice__text">
          กฎที่ชน: <code className="cap-table__code">{rule}</code>
        </p>
      )}
      {serverMessage === null ? null : (
        <p className="cap-notice__note" data-testid="manual-plan-create-failure-message">
          ข้อความจากเซิร์ฟเวอร์: {serverMessage}
        </p>
      )}
    </div>
  );
}

interface ManualPlanProductCellProps {
  readonly position: number;
  readonly value: string;
  readonly disabled: boolean;
  readonly products: ManualPlanProductsState;
  readonly onCodeChange: (value: string) => void;
  readonly onResolved: (product: Product) => void;
}

/**
 * ช่องรหัสสินค้าแบบ Select2 (D-136) — เลือกจากทะเบียนที่โหลดมาครั้งเดียวตอนเปิดหน้า
 * ผ่าน `SearchableSelect` (component กลาง ไม่รู้จักสินค้า) `allowCustom` เปิดเมื่อ
 * ทะเบียนยังไม่ครบ/โหลดไม่สำเร็จ (D-132) เพื่อให้พิมพ์รหัสเองได้ผ่าน 'ใช้รหัส "…"'
 * เลือกแล้ว resolve ผ่าน `findProductByExactCode` ก่อนเสมอ — ค่าที่ไม่ตรงสินค้าใด
 * (รหัสจากแผนเดิมที่สินค้าถูกลบ หรือพิมพ์เองตอนทะเบียนไม่ครบ) ยัง `onCodeChange` ตาม
 * เดิมเพื่อให้ error 'ไม่พบรหัสสินค้านี้' ทำงานต่อได้
 */
function ManualPlanProductCell({ position, value, disabled, products, onCodeChange, onResolved }: ManualPlanProductCellProps) {
  const items = products.status === 'ready' ? products.items : [];
  const options = manualPlanProductSelectOptions(items);
  const registryIncomplete = products.status !== 'ready' || !products.complete;

  return (
    <SearchableSelect
      options={options}
      value={value}
      disabled={disabled}
      clearable
      allowCustom={registryIncomplete}
      ariaLabel={`รหัสสินค้า บรรทัดที่ ${position}`}
      testId={`manual-plan-create-line-product-${position}`}
      onChange={(nextValue) => {
        if (nextValue === '') {
          onCodeChange('');
          return;
        }
        const match = findProductByExactCode(items, nextValue);
        if (match !== null) {
          onResolved(match);
          return;
        }
        onCodeChange(nextValue);
      }}
    />
  );
}

export function ManualPlanCreateView(props: ManualPlanCreateViewProps) {
  const { permissions, apiBaseUrl, fetchImpl, copyFromMpsId } = props;
  const navigate = useNavigate();
  const location = useLocation();
  const plants = selectablePlants(permissions);
  const trimmedCopyFromMpsId = copyFromMpsId?.trim() ?? '';

  const [header, setHeader] = useState<ManualPlanHeaderDraft>(() => ({
    plantCode: plants[0] ?? '',
    horizonStart: '',
    horizonEnd: '',
    note: '',
  }));
  const [lines, setLines] = useState<readonly ManualPlanLineDraft[]>([emptyLine(0)]);
  const [nextKey, setNextKey] = useState(1);
  const [submitAttempted, setSubmitAttempted] = useState(false);
  const [pending, setPending] = useState(false);
  const [failure, setFailure] = useState<MpsFailure | null>(null);
  const [copySource, setCopySource] = useState<CopySourceState>(
    trimmedCopyFromMpsId === '' ? { status: 'idle' } : { status: 'loading' },
  );
  const [products, setProducts] = useState<ManualPlanProductsState>({ status: 'loading' });
  const [productsReloadToken, setProductsReloadToken] = useState(0);

  useEffect(() => {
    if (trimmedCopyFromMpsId === '') {
      return;
    }
    let active = true;
    const controller = new AbortController();

    void fetchMpsVersion(trimmedCopyFromMpsId, {
      apiBaseUrl,
      fetchImpl,
      signal: controller.signal,
    }).then((result) => {
      if (!active || result.status === 'cancelled') {
        return;
      }
      if (result.status !== 'ready') {
        setCopySource({ status: 'failed', failure: result });
        return;
      }
      const draft = manualPlanDraftFromVersion(result.version);
      setHeader(draft.header);
      setLines(draft.lines.length === 0 ? [emptyLine(0)] : draft.lines);
      setNextKey(Math.max(draft.lines.length, 1));
      setCopySource({ status: 'done' });
    });

    return () => {
      active = false;
      controller.abort();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [trimmedCopyFromMpsId]);

  /**
   * โหลดทะเบียนสินค้าตอนเปิดหน้า (D-132 ข้อ 2) — ไล่ตาม `next_cursor` จนครบหรือจนชน
   * `MANUAL_PLAN_PRODUCT_MAX_PAGES` หน้าใดพังกลางทางหยุดไล่ต่อทันที (เก็บเฉพาะหน้าที่
   * ได้มาแล้ว) ไม่ยิงซ้ำต่อบรรทัด/ต่อคำค้น — การไล่หน้าทั้งหมดนี้ยังนับเป็น "ครั้งเดียว
   * ต่อการเปิดหน้า" ตาม invariant เดิม
   */
  useEffect(() => {
    let active = true;
    const controller = new AbortController();
    setProducts({ status: 'loading' });

    void (async () => {
      const items: Product[] = [];
      let cursor: string | undefined;
      let pageFailed = false;
      let complete = false;

      for (let page = 0; page < MANUAL_PLAN_PRODUCT_MAX_PAGES; page += 1) {
        const result = await fetchProductList(
          { status: 'ACTIVE', limit: MANUAL_PLAN_PRODUCT_PAGE_LIMIT, cursor },
          { apiBaseUrl, fetchImpl, signal: controller.signal },
        );
        if (result.status === 'cancelled') {
          return;
        }
        if (result.status !== 'ready') {
          pageFailed = true;
          break;
        }
        items.push(...result.page.items);
        if (result.page.next_cursor === null) {
          complete = true;
          break;
        }
        cursor = result.page.next_cursor;
      }

      if (!active) {
        return;
      }
      if (pageFailed && items.length === 0) {
        setProducts({ status: 'failed' });
        return;
      }
      setProducts({ status: 'ready', items, complete: complete && !pageFailed });
    })();

    return () => {
      active = false;
      controller.abort();
    };
  }, [apiBaseUrl, fetchImpl, productsReloadToken]);

  /**
   * resolve รหัสที่คัดลอกมาจากแผนต้นทาง (`copyFromMpsId`) ทันทีที่ทะเบียนสินค้า
   * พร้อม — บรรทัดที่เลือก/พิมพ์เองผ่าน `SearchableSelect` ถูก resolve ที่ `onChange`
   * ของมันไปแล้ว จึงข้าม (`productName !== ''`) effect นี้จึงไม่มีทางเขียนทับสิ่งที่ผู้ใช้แก้ไว้
   */
  useEffect(() => {
    if (products.status !== 'ready') {
      return;
    }
    setLines((previous) =>
      previous.map((line) => {
        if (line.productName !== '' || line.productCode.trim() === '') {
          return line;
        }
        const match = findProductByExactCode(products.items, line.productCode);
        return match === null ? line : withResolvedManualPlanLineProduct(line, match);
      }),
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [products.status, copySource.status]);

  /** `null` เว้นแต่ทะเบียนครบจริง (`complete`) — ไม่ครบ/พังกลางทางต้องปล่อยให้เซิร์ฟเวอร์ตัดสิน */
  const knownProductCodes =
    products.status === 'ready' && products.complete
      ? new Set(products.items.map((product) => product.product_code.toUpperCase()))
      : null;
  const validation = validateManualPlanDraft(header, lines, knownProductCodes);
  const body = toMpsVersionCreateBody(header, lines, knownProductCodes);

  const updateHeader = (field: keyof ManualPlanHeaderDraft, value: string) => {
    setHeader((previous) => ({ ...previous, [field]: value }));
  };

  const updateLine = (key: number, field: keyof Omit<ManualPlanLineDraft, 'key'>, value: string) => {
    setLines((previous) =>
      previous.map((line) => (line.key === key ? { ...line, [field]: value } : line)),
    );
  };

  const handleLineProductCodeChange = (key: number, value: string) => {
    setLines((previous) =>
      previous.map((line) =>
        line.key === key ? withClearedManualPlanLineProductCode(line, value) : line,
      ),
    );
  };

  const handleLineProductResolved = (key: number, product: Product) => {
    setLines((previous) =>
      previous.map((line) =>
        line.key === key ? withResolvedManualPlanLineProduct(line, product) : line,
      ),
    );
  };

  const addLine = () => {
    setLines((previous) => [...previous, emptyLine(nextKey)]);
    setNextKey((key) => key + 1);
  };

  const removeLine = (key: number) => {
    setLines((previous) => previous.filter((line) => line.key !== key));
  };

  const submit = async () => {
    if (body === null || pending) {
      return;
    }
    setPending(true);
    setFailure(null);
    const result = await createMpsVersion(body, { apiBaseUrl, fetchImpl });
    setPending(false);
    if (result.status === 'cancelled') {
      return;
    }
    if (result.status !== 'ready') {
      // ไม่ล้างฟอร์ม — สิ่งที่กรอกไว้ทั้งหัวแผนและทุกบรรทัดยังอยู่ครบให้แก้แล้วส่งใหม่ได้
      setFailure(result);
      return;
    }
    navigate(`/planning/production-plan?mps=${result.version.mps_id}`, {
      state: { manualPlanCreated: { versionLabel: result.version.version_label } },
    });
  };

  const handleCancel = () => {
    if (location.key !== 'default') {
      navigate(-1);
      return;
    }
    navigate('/planning/production-plan');
  };

  return (
    <div className="cap-page" data-testid="manual-plan-create">
      <div className="cap-page__head">
        <div>
          <h1 className="cap-page__title">
            สร้างแผนใหม่
            <InfoHint
              label="เกี่ยวกับหน้านี้"
              text="แผนที่สร้างที่นี่เป็นร่าง (DRAFT) เสมอ — ต้องให้ผู้อื่นอนุมัติต่อ (D-010: ผู้อนุมัติต้องไม่ใช่ผู้สร้าง) แก้บรรทัดทับของแผนเดิมไม่ได้ ปรับแผนคือสร้างเวอร์ชันใหม่ (D-129)"
            />
          </h1>
        </div>
      </div>

      {copySource.status === 'loading' ? (
        <div className="cap-notice" data-testid="manual-plan-create-copy-loading" role="status">
          <p className="cap-notice__text">กำลังโหลดแผนต้นทางเพื่อเติมฟอร์ม…</p>
        </div>
      ) : null}

      {copySource.status === 'failed' ? (
        <div className="cap-notice" data-testid="manual-plan-create-copy-failed" role="status">
          <StatusBadge tone="warning">โหลดแผนต้นทางไม่สำเร็จ</StatusBadge>
          <p className="cap-notice__text">
            {copySource.failure.status === 'not-found'
              ? 'ไม่พบแผนต้นทางนี้'
              : 'โหลดแผนต้นทางไม่สำเร็จ'}{' '}
            — เริ่มจากฟอร์มเปล่าได้ตามปกติ
          </p>
        </div>
      ) : null}

      <form
        className="cap-form"
        noValidate
        data-testid="manual-plan-create-form"
        aria-label="สร้างแผนผลิตแบบ Manual"
        onSubmit={(event) => {
          event.preventDefault();
          setSubmitAttempted(true);
          void submit();
        }}
      >
        <label className="cap-field">
          <span className="cap-field__label">โรงงาน</span>
          <select
            className="cap-input"
            name="plant_code"
            data-testid="manual-plan-create-plant"
            value={header.plantCode}
            disabled={pending}
            onChange={(event) => {
              updateHeader('plantCode', event.target.value);
            }}
          >
            {plants.length === 0 ? <option value="">— ไม่มีโรงงานที่คุณเห็น —</option> : null}
            {plants.map((code) => (
              <option key={code} value={code}>
                โรงงาน {code}
              </option>
            ))}
          </select>
          {submitAttempted && validation.headerErrors.plantCode ? (
            <p className="cap-field__hint cap-field__hint--error" data-testid="manual-plan-create-plant-error">
              เลือกโรงงาน
            </p>
          ) : null}
        </label>

        <p className="cap-field__hint" data-testid="manual-plan-create-auto-number-hint">
          เลขแผนออกให้อัตโนมัติ
          <InfoHint
            label="เกี่ยวกับเลขแผน"
            text="ไม่ต้องตั้งชื่อเวอร์ชันเอง — เซิร์ฟเวอร์ออกเลขแผนรูปแบบ MPS-<โรงงาน>-<ปีเดือน>-<เลขรัน> ให้อัตโนมัติทันทีที่บันทึก (D-132)"
          />
        </p>

        <DateRangePicker
          label="ช่วงวางแผน"
          from={header.horizonStart}
          to={header.horizonEnd}
          testId="manual-plan-create-horizon"
          onChange={(from, to) => {
            setHeader((previous) => ({ ...previous, horizonStart: from, horizonEnd: to }));
          }}
        />
        {submitAttempted && validation.headerErrors.horizon ? (
          <p className="cap-field__hint cap-field__hint--error" data-testid="manual-plan-create-horizon-error">
            เลือกช่วงวางแผนให้ครบทั้งวันเริ่มและวันสิ้นสุด
          </p>
        ) : null}

        <label className="cap-field">
          <span className="cap-field__label">หมายเหตุ (ไม่บังคับ)</span>
          <input
            className="cap-input"
            name="note"
            data-testid="manual-plan-create-note"
            value={header.note}
            maxLength={MPS_NOTE_MAX_LENGTH}
            autoComplete="off"
            disabled={pending}
            onChange={(event) => {
              updateHeader('note', event.target.value);
            }}
          />
        </label>

        <fieldset className="cap-field" data-testid="manual-plan-create-lines">
          <legend className="cap-field__label">
            บรรทัดของแผน
            <InfoHint
              label="เกี่ยวกับตารางบรรทัด"
              text="สินค้า × วัน × จำนวน — รหัสสินค้าและวันที่ของบรรทัดเดียวกันซ้ำกันไม่ได้ วันที่ต้องอยู่ในช่วงวางแผนด้านบน และต้องมีอย่างน้อยหนึ่งบรรทัดที่กรอกครบ พิมพ์หรือเลือกรหัสสินค้าที่มีในระบบเพื่อให้ Part Name/Model ขึ้นให้อัตโนมัติ"
            />
          </legend>

          {products.status === 'failed' || (products.status === 'ready' && !products.complete) ? (
            <p className="cap-field__hint" data-testid="manual-plan-create-products-failed">
              โหลดรายการสินค้าไม่สำเร็จ — พิมพ์รหัสสินค้าด้วยมือได้ตามปกติ{' '}
              <button
                type="button"
                className="cap-button cap-button--ghost"
                data-testid="manual-plan-create-products-retry"
                onClick={() => {
                  setProductsReloadToken((token) => token + 1);
                }}
              >
                ลองอีกครั้ง
              </button>
            </p>
          ) : null}

          <div className="cap-table-wrap">
            <table className="cap-table" data-testid="manual-plan-create-lines-table">
              <thead>
                <tr>
                  <th scope="col">รหัสสินค้า</th>
                  <th scope="col">Part Name</th>
                  <th scope="col">Model</th>
                  <th scope="col">วันที่</th>
                  <th scope="col">จำนวน</th>
                  <th scope="col">ข้อผิดพลาด</th>
                  <th scope="col">การกระทำ</th>
                </tr>
              </thead>
              <tbody>
                {lines.map((line, index) => {
                  const errorCode = validation.lineErrors.get(line.key) ?? null;
                  return (
                    <tr key={line.key} data-testid={`manual-plan-create-line-${index + 1}`}>
                      <td>
                        <ManualPlanProductCell
                          position={index + 1}
                          value={line.productCode}
                          disabled={pending}
                          products={products}
                          onCodeChange={(value) => {
                            handleLineProductCodeChange(line.key, value);
                          }}
                          onResolved={(product) => {
                            handleLineProductResolved(line.key, product);
                          }}
                        />
                      </td>
                      <td>
                        <span className="cap-table__muted" data-testid={`manual-plan-create-line-name-${index + 1}`}>
                          {line.productName === '' ? '—' : line.productName}
                        </span>
                      </td>
                      <td>
                        <span className="cap-table__muted" data-testid={`manual-plan-create-line-model-${index + 1}`}>
                          {line.model === '' ? '—' : line.model}
                        </span>
                      </td>
                      <td>
                        <input
                          className="cap-input"
                          type="date"
                          data-testid={`manual-plan-create-line-date-${index + 1}`}
                          aria-label={`วันที่ บรรทัดที่ ${index + 1}`}
                          value={line.bucketDate}
                          min={header.horizonStart === '' ? undefined : header.horizonStart}
                          max={header.horizonEnd === '' ? undefined : header.horizonEnd}
                          disabled={pending}
                          onChange={(event) => {
                            updateLine(line.key, 'bucketDate', event.target.value);
                          }}
                        />
                      </td>
                      <td>
                        <input
                          className="cap-input"
                          data-testid={`manual-plan-create-line-qty-${index + 1}`}
                          aria-label={`จำนวน บรรทัดที่ ${index + 1}`}
                          value={line.plannedQty}
                          inputMode="decimal"
                          autoComplete="off"
                          disabled={pending}
                          onChange={(event) => {
                            updateLine(line.key, 'plannedQty', event.target.value);
                          }}
                        />
                      </td>
                      <td>
                        {submitAttempted && errorCode !== null ? (
                          <span
                            className="cap-field__hint cap-field__hint--error"
                            data-testid={`manual-plan-create-line-error-${index + 1}`}
                          >
                            {manualPlanLineErrorLabel(errorCode)}
                          </span>
                        ) : (
                          '—'
                        )}
                      </td>
                      <td>
                        <button
                          type="button"
                          className="cap-button cap-button--ghost cap-button--icon"
                          data-testid={`manual-plan-create-line-remove-${index + 1}`}
                          aria-label={`ลบบรรทัดที่ ${index + 1}`}
                          title={`ลบบรรทัดที่ ${index + 1}`}
                          disabled={pending}
                          onClick={() => {
                            removeLine(line.key);
                          }}
                        >
                          <span aria-hidden="true">🗑️</span>
                        </button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>

          <button
            type="button"
            className="cap-button cap-button--ghost cap-button--icon"
            data-testid="manual-plan-create-line-add"
            aria-label="เพิ่มบรรทัด"
            title="เพิ่มบรรทัด"
            disabled={pending}
            onClick={addLine}
          >
            <span aria-hidden="true">➕</span>
          </button>

          {submitAttempted && validation.filledLineCount === 0 ? (
            <p className="cap-field__hint cap-field__hint--error" data-testid="manual-plan-create-lines-error">
              ต้องมีอย่างน้อยหนึ่งบรรทัดที่กรอกรหัสสินค้า วันที่ และจำนวนครบ
            </p>
          ) : null}
        </fieldset>

        <div className="cap-form__actions">
          <button
            type="submit"
            className="cap-button cap-button--primary"
            data-testid="manual-plan-create-submit"
            disabled={pending}
          >
            {pending ? 'กำลังบันทึก…' : 'บันทึกเป็นแผนร่าง'}
          </button>
          <button
            type="button"
            className="cap-button cap-button--ghost"
            data-testid="manual-plan-create-cancel"
            disabled={pending}
            onClick={handleCancel}
          >
            ยกเลิก
          </button>
        </div>

        {failure === null ? null : <CreateFailureNotice failure={failure} />}
      </form>
    </div>
  );
}
